import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IsAdminService {
  // Initialisiere BehaviorSubject mit einem Default-Wert (false)
  private isAdminSubject = new BehaviorSubject<boolean>(false);

  // Exponiere das Observable für Abonnements
  public isAdmin$: Observable<boolean> = this.isAdminSubject.asObservable();

  constructor(private router: Router) {}

  public checkIfAdminPath(): void {
    const isAdmin = this.router.url.includes('/admin');
    this.setIsAdmin(isAdmin);
  }

  // Methode zum Setzen des Admin-Status
  public setIsAdmin(isAdmin: boolean): void {
    this.isAdminSubject.next(isAdmin);
  }

  // Methode zum Abfragen des aktuellen Admin-Status
  public getCurrentIsAdmin(): boolean {
    return this.isAdminSubject.getValue();
  }
}
